import React from "react";
import { observer } from "mobx-react";
import {useTranslate} from "../../../../hooks/translate.hook";
import {Typography} from "antd";
import { displayPrice } from "../../../../models/prices/price.helper";
import { MetaProps } from "../../../common/graph/graph";
import { ReportPaymentsStats } from "../../../../models/reports/reports";

export const ReportsMainPageStats: React.FC<MetaProps<ReportPaymentsStats>> =
    observer(({meta: {total, currentMonthTotal}}) => {
        const t = useTranslate();

        return (
            <div className="reports-summary">
                <div className="reports-summary__item">
                    <Typography.Text className="reports-summary__label">
                        {t("REPORTS.SOLD.TOTAL")}
                    </Typography.Text>
                    <Typography.Text className="reports-summary__value">
                        {displayPrice(total)}
                    </Typography.Text>
                </div>
                <div className="reports-summary__item">
                    <Typography.Text className="reports-summary__label">
                        {t("REPORTS.SOLD.THIS_MONTH")}
                    </Typography.Text>
                    <Typography.Text className="reports-summary__value">
                        {displayPrice(currentMonthTotal)}
                    </Typography.Text>
                </div>
            </div>
        );
    });
